<template>
  <div
    v-if="isShowPage"
    class="help"
  >
    <nav-pc tips="1" />
    <!-- 會員條款 id = 1 -->
    <div
      v-if="value == 1"
      class="content"
    >
      <van-nav-bar
        :title="lang.provisionTit"
        :left-arrow="!$route.query.fromapp"
        class="navBar"
        @click-left="close"
      />
      <p
        class="text"
        v-html="lang.provision"
      />
    </div>
    <!-- 隱私政策 id = 2 -->
    <div
      v-if="value == 2"
      class="content"
    >
      <van-nav-bar
        :title="lang.privacyTit"
        :left-arrow="!$route.query.fromapp"
        class="navBar"
        @click-left="close"
      />
      <p
        class="text"
        v-html="lang.privacy"
      />
    </div>
    <!-- 服務條款	 id = 3 -->
    <div
      v-if="value == 3"
      class="content"
    >
      <van-nav-bar
        :title="lang.ServiceTit"
        :left-arrow="!$route.query.fromapp"
        class="navBar"
        @click-left="close"
      />
      <p
        class="text"
        v-html="lang.Service"
      />
    </div>
    <!-- 放盘条款 id = 4 -->
    <div
      v-if="value == 4"
      class="content"
    >
      <van-nav-bar
        :title="lang.post"
        :left-arrow="!$route.query.fromapp"
        class="navBar"
        @click-left="close"
      />
      <p
        class="text"
        v-html="lang.postText"
      />
    </div>
    <!-- 留言条款 id = 5 -->
    <!-- <div class="content" v-if="value == 5">
      <van-nav-bar :title="lang.leaveTit" :left-arrow="!$route.query.fromapp" @click-left="close" class="navBar" />
      <p v-html="lang.leave" class="text"></p>
    </div> -->
  </div>
</template>

<script>
import pub from '../../common/public';
import navPc from './../components/navBar-pc';
import lang from './../../common/language/help';
export default {
  name: 'Help',
  components: {
    navPc,
  },
  data() {
    return {
      isShowPage: false,
      lang,
      value: '',
      title: '',
      isPc: false,
    };
  },
  created() {
    this.isPc = !(document.body.clientWidth <= 750 || /mobi|android|iphone|blackberry|ipod|iemobile/i.test(navigator.userAgent.toLocaleLowerCase()))
    if (!this.isPc) {
      this.isShowPage = true;
    }
    this.value = this.$route.query.id;
    if (this.value == 1) {
      this.title = this.lang.provisionTit;
      this.pageJump(1)
    } else if (this.value == 2) {
      this.title = this.lang.privacyTit;
      this.pageJump(2)
    } else if (this.value == 3) {
      this.title = this.lang.ServiceTit;
      this.pageJump(3)
    } else if (this.value == 4) {
      this.title = this.lang.post;
      this.pageJump(4)
    } 
    // else if (this.value == 5) {
    //   this.pageJump(5)
    // }
  },
  methods: {
    pageJump(id) {
      if (this.isPc) {
        if (id == 1) {
          if (pub.getLang() === 'zh-cn') {
            location.href = `${pub.config.pcUrl}zh-cn/help/membershipclauses/`;
          } else if (pub.getLang() === 'en-us') {
            location.href = `${pub.config.pcUrl}en-us/help/membershipclauses/`;
          } else {
            location.href = `${pub.config.pcUrl}help/membershipclauses/`;
          }
        } else if (id == 2) {
          if (pub.getLang() === 'zh-cn') {
            location.href = `${pub.config.pcUrl}zh-cn/help/privacypolicy/`;
          } else if (pub.getLang() === 'en-us') {
            location.href = `${pub.config.pcUrl}en-us/help/privacypolicy/`;
          } else {
            location.href = `${pub.config.pcUrl}help/privacypolicy/`;
          }
        } else if (id == 3) {
          if (pub.getLang() === 'zh-cn') {
            location.href = `${pub.config.pcUrl}zh-cn/help/servicepolicy/`;
          } else if (pub.getLang() === 'en-us') {
            location.href = `${pub.config.pcUrl}en-us/help/servicepolicy/`;
          } else {
            location.href = `${pub.config.pcUrl}help/servicepolicy/`;
          }
        } else if (id == 4) {
          if (pub.getLang() === 'zh-cn') {
            location.href = `${pub.config.pcUrl}zh-cn/help/placementclause/`;
          } else if (pub.getLang() === 'en-us') {
            location.href = `${pub.config.pcUrl}en-us/help/placementclause/`;
          } else {
            location.href = `${pub.config.pcUrl}help/placementclause/`;
          }
        } 
        // else if (id == 5) {
        //   if (pub.getLang() === 'zh-cn') {
        //     location.href = `${pub.config.pcUrl}zh-cn/help/leavingmessage/`;
        //   } else if (pub.getLang() === 'en-us') {
        //     location.href = `${pub.config.pcUrl}en-us/help/leavingmessage/`;
        //   } else {
        //     location.href = `${pub.config.pcUrl}help/leavingmessage/`;
        //   }
        // }
      }
    },
    close() {
      window.history.go(-1);
    },
  },
  metaInfo() {
    return {
      title: this.title,
    };
  },
};
</script>

<style lang="scss" >
@media screen and (min-width: 601px) {
  .navBar {
    display: none;
  }
  .content {
    padding: 30px 0px;
    margin: auto;
    width: 990px;
  }
}
.center {
  text-align: center;
}
a.hrefs:link,
a.hrefs:visited,
a.hrefs:active {
  color: #2c3e50;
}
.imgViewHelp {
  width: 153px;
  height: 14px;
  display: inline-block;
  background-image: url(../assets/email.png);
}
.text {
  line-height: 21px;
  font-size: 14px;
  padding: 18px;
}
#ul {
  list-style-type: disc !important;
}
.blod {
  font-weight: 600;
}
.help {
  font-size: 15px;
  text-align: left;
  line-height: 20px;
}

.van-nav-bar {
  border-bottom: 1px solid #e3e4e6;
  background-color: #fafbfc;
}
.van-nav-bar__title {
  font-size: 17px;
  font-weight: 600;
}
.van-nav-bar__text {
  color: #333;
}
.van-nav-bar .van-icon {
  font-size: 25px;
  color: black;
}
</style>
